import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { format } from "date-fns";

const SpecialDatePicker = (prop) => {
  const [selectedDate, setSelectedDate] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [highlightDates, setHighlightDates] = useState([]);
  const [API_date, setAPI_date] = useState([]);
  const [special_date, Setspecial_date] = useState("");

  useEffect(() => {
    // Call Jain calendar API to fetch all dates and set them as highlighted dates
    const fetchHinduCalendarDates = async () => {
      let datas = {
        fn: "common_fn",
        se: "ge_ca",
        data: {
          date: `${selectedDate || new Date()}`,
        },
      };

      try {
        const response = await axios.post(
          "https://app.ratnasangh.com/common",
          {
            payload: JSON.stringify(datas),
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // console.log(response.data);

        let date_high = response.data
          .map((e) => {
            if (
              e.JainFestivals_hindi !== "" ||
              e.NationalFestivals_hindi !== ""
            ) {
              return e.Date;
            }
          })
          .filter((e) => e != undefined);

        // console.log(date_high);

        setHighlightDates(date_high);
        setAPI_date(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchHinduCalendarDates();
  }, [selectedDate]);

  //--------input change handdler-----////

  function inputclickhanadler() {
    setShowDatePicker(true);
  }

  ///-----------------select handler-----------------------///////////
  const handleSelectDate = (date) => {
    const formattedDate = format(date, "d-M-yyyy");

    let date_detail = API_date.map((e) => {
      if (e.Date === formattedDate) {
        return `${e.Shukla_hindi} ${e.Tithi_hindi}  ${e.JainFestivals_hindi} ${e.NationalFestivals_hindi}`;
      }
    }).filter((e) => e != undefined);

    // console.log(date_detail);
    Setspecial_date(date_detail);
    setSelectedDate(date);
  };

  ////------------select btn handler------------/////////////////////////

  const handleSelectButtonClick = () => {
    setShowDatePicker(false);

    // console.log(format(selectedDate, "yyyy-MM-dd"));
    prop.dateupdate(format(selectedDate, "yyyy-MM-dd"), special_date);
    // Do something with selected date, such as displaying associated festival
  };

  let d = highlightDates;
  let x = d.map((e) => {
    // let mm=e.toString().replaceAll("-",",")
    const [day, month, year] = String(e).split("-");
    return new Date(`${year},${month},${day}`);
  });
  // console.log(x);

  const highlightDatese = [
    // Array of dates to highlight, for example special festival dates
    // new Date(year, days, Month),

    // new Date(2023, 4, 28),
    ...x,
  ];
  ////////////--------------------//

  return (
    <div>
      <input
        type="text"
        placeholder="Select a date"
        defaultValue={
          selectedDate ? `${format(selectedDate, "dd-MM-yyyy")}` : ""
        }
        onClick={() => inputclickhanadler()}
      />{" "}
      {showDatePicker && (
        <div className="ppppppppp">
          <DatePicker
            selected={selectedDate}
            onChange={handleSelectDate}
            highlightDates={highlightDatese}
            dateFormat="d-M-yyyy"
            inline
          />
          <button className="a-fetch-button" onClick={handleSelectButtonClick}>
            {" "}
            Select{" "}
          </button>{" "}
        </div>
      )}
    </div>
  );
};

export default SpecialDatePicker;
